import { SubmitHandler } from "react-hook-form";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { ProfileFormData } from "../profile-components/profile-form-data";
import { useToast } from "shared/toast/hooks/use-toast";

import { usePostApiProfileinfoMutation } from "api/generatedApi";
import { useTranslation } from "react-i18next";

export function useProfileSubmit() {
  const { t } = useTranslation();
  const [updateProfile] = usePostApiProfileinfoMutation();

  const wrapMutation = useMutation({
    onSuccess: () => {},
    successProps: {
      description: t("account.profilePage.onSuccessToast"),
    },
    errorProps: {
      description: t("account.profilePage.onFailedToast"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit: SubmitHandler<ProfileFormData> = (data) => {
    wrapMutation(
      updateProfile({
        profileInfoRequest: {
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          company: data.companyName,
          notificationOptions: data.notificationOptions,
        },
      })
    );
  };
  const onSubmit = (data: ProfileFormData) => {
    handleOnSubmit(data);
  };

  return { onSubmit };
}
